import React, { useEffect } from "react";
import { Row, Col, Image, Button, Form } from "react-bootstrap";
import { MagnifierIcon, SaveIcon } from "../../assets/svg/svg-icons";
import { useDispatch, useSelector } from "react-redux";
import plastic1 from "../../assets/images/plastic-1.png";
import "react-image-gallery/styles/css/image-gallery.css";
import "./account.css";
import { getApi } from "../../actions/structure.action";
import isEmpty from "../../utils/is-Empty";
import { Link } from "react-router-dom";
import TimestampConverter from "../../utils/TimestampConverter";
import { capitalize } from "lodash";
import StatusBadge from "./StatusBadge";
import moment from "moment";

const OrdersList = () => {
  const dispatch = useDispatch();

  const { orders } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getOrders", dispatch);
  }, []);

  const orderSummaryAccount = (item, index) => {
    let paymentStatusClass = "";
    if (item?.payment_status_id === "pending") {
      paymentStatusClass = "text-warning";
    } else if (item?.payment_status_id === "success") {
      paymentStatusClass = "text-success";
    } else {
      paymentStatusClass = "text-danger";
    }

    const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
    const orderDate = item?.createdAt
      ? moment(item.createdAt).tz("Asia/Kolkata").format("YYYY-MM-DD")
      : null;
    const highlight = orderDate === todayDate;

    let orderSize =
      item?.product_variant_id[0].quantity >= 1000
        ? item?.product_variant_id[0].quantity / 1000 + " L"
        : item?.product_variant_id[0].quantity + " ml";

    return (
      <Link
        key={`${index}_Order_${item?.orderId}`}
        className="order-link"
        to={`/order/${item?.id}`}
      >
        <Row
          className={`order-summery-card-my-account m-0 mb-4`}
          style={{ backgroundColor: highlight ? "#e6ffe6" : "#ffffff" }}
        >
          <Col xs={2} sm={2} md={2} className="image-col">
            <Image
              src={item?.product_variant_id[0]?.productImages[0]?.url || plastic1}
              alt={item?.product_variant_id[0]?.brand_name}
            />
          </Col>
          <Col xs={10} sm={10} md={10}>
            <Row className="m-0 p-0">
              <Col xs={12} sm={12} md={12} className="m-0 p-0 text-start summary-card-title">
                <Row className="m-0 p-0">
                  <Col md={6} xs={6} className="m-0 p-0">
                    <span className="m-0 p-0 small muted">{`# ${item?.orderId}`}</span>
                  </Col>
                  <Col md={6} xs={6} className="m-0 p-0 text-end">
                    <StatusBadge status={item?.status} />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={12} md={12} className="m-0 p-0 mt-1 text-start">
                <div className="summary-card-title">
                  {!isEmpty(item?.offerPrice) ? (
                    <span>
                      {`${item?.product_variant_id[0].brand_name} - ${item?.product_variant_id[0].product_name} | ₹ ${item?.offerPrice}/case`}{" "}
                      <s>{`₹ ${item?.price}/case`}</s>{" "}
                    </span>
                  ) : (
                    <span>{`${item?.product_variant_id[0].brand_name} - ${item?.product_variant_id[0].product_name} | ₹ ${item?.price}/case`}</span>
                  )}
                </div>
                <hr className="m-0 p-0 my-1" style={{ width: "100%" }} />
                <div className="summary-card-details">
                  <Row>
                    <Col xs={2} sm={2} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted mb-2">{"Size"}</p>
                      <h6 className="small">{`${orderSize}`}</h6>
                    </Col>
                    <Col xs={2} sm={2} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted mb-2">{"MOQ"}</p>
                      <h6 className="small">{` ${item?.moq} Case`}</h6>
                    </Col>
                    <Col xs={3} sm={3} md={2} className="my-acccount-summary-card-item">
                      <p className="small muted mb-2">{"Amount"}</p>
                      <h6 className="small">
                        {"₹  "}
                        {!isEmpty(item?.offerPrice)
                          ? parseInt(item?.moq) * parseInt(item.offerPrice)
                          : parseInt(item?.moq) * parseInt(item.price)}
                      </h6>
                    </Col>
                    <Col xs={5} sm={5} md={4} className="my-acccount-summary-card-item">
                      <p className="small muted mb-2">{"Status"}</p>
                      <h6 className="small">
                        {"Payment: "}
                        <span className={`${paymentStatusClass}`}>
                          {item?.payment_status_id?.toUpperCase()}
                        </span>
                      </h6>
                    </Col>
                    <Col md={2} className="text-end desktop">
                      <div
                        className="d-flex align-items-center justify-content-end"
                        style={{ height: "100%" }}
                      >
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="text-uppercase"
                          disabled
                          style={{ fontSize: "12px" }}
                        >
                          {"invoice "}
                          <i className="bi bi-download"></i>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row className="m-0 p-0">
              <Col xs={6} className="m-0 p-0 text-start">
                {(() => {
                  if (!isEmpty(item?.delivered_at)) {
                    return (
                      <span className="small m-0 p-0 muted">
                        Actual Delivery Date: {TimestampConverter(item?.delivered_at, true)}
                      </span>
                    );
                  } else {
                    return (
                      <span className="small m-0 p-0 muted">
                        Expected Delivery Date:{" "}
                        {TimestampConverter(item?.expected_delivery_date, true)}
                      </span>
                    );
                  }
                })()}
              </Col>
              <Col xs={6} className="m-0 p-0 text-end mobile">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="text-uppercase"
                  style={{ fontSize: "12px" }}
                  disabled
                >
                  {"invoice "}
                  <i className="bi bi-download"></i>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Link>
    );
  };

  return (
    <>
      <div className="my-order-headingbox">
        <h4 className="text-uppercase m-0">{"my orders"}</h4>
        <div className="search-and-dropdown-box">
          <MagnifierIcon />
          <Form.Select aria-label="Default select example">
            <option value="1">{"Last 3 month"}</option>
            <option value="2">{"Last 6 month"}</option>
            <option value="3">{"Last 9 month"}</option>
          </Form.Select>
        </div>
      </div>
      <hr />
      <div
        style={{
          maxHeight: "36rem",
          overflowY: "auto",
        }}
      >
        {!isEmpty(orders?.data) &&
          orders?.data?.length > 0 &&
          orders.data.map((item, index) => {
            return orderSummaryAccount(item, index);
          })}
        {isEmpty(orders?.data) && <p>{"No orders placed"}</p>}
      </div>
    </>
  );
};

export default OrdersList;
